export enum LiveSpaceUpdateType {
	Init,
	Change,
	Full,
	Over,
}

export type LiveSpaceUpdateFull = {
	type: LiveSpaceUpdateType.Full
}

export type LiveSpaceUpdateOver = {
	type: LiveSpaceUpdateType.Over
}

export type LiveSpaceUpdateInit = {
	type: LiveSpaceUpdateType.Init
	liveSpace: LiveSpace
}

export type LiveSpaceUpdateChange = {
	type: LiveSpaceUpdateType.Change
	liveSpace: {
		title: string
		logoUrl?: string
		startDate?: Date
		isPrivate: boolean
		colorScheme: {
			roomColor: string[]
			moderator: string
		}
		organizationCode?: string
		isOver: boolean
	}
}

export type LiveSpace = {
	code: string
	title: string
	logoUrl?: string
	startDate?: Date
	creator: string
	isPrivate: boolean
	colorScheme: {
		roomColor: string[]
		moderator: string
	}
	organizationCode?: string
	isOver: boolean
}
